export default __webpack_public_path__ + "static/media/Project09.98834122.jpg";